import React, { useRef } from "react";
import Box from "@mui/material/Box";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function DropdownView({ value }) {
  const ref = useRef();

  const handleClick = () => {
    const event = new MouseEvent("dblclick", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    ref.current.parentElement.dispatchEvent(event);
  };

  return (
    <Box
      ref={ref}
      width="100%"
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      gap={0.5}
      sx={{ overflow: "hidden" }}
    >
      <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {value || ""}
      </Box>
      <IconButton size="small" onClick={handleClick} sx={{ p: 0.25 }}>
        <Tooltip title="Open">
          <ArrowDropDownIcon color="action" />
        </Tooltip>
      </IconButton>
    </Box>
  );
}
